import { render, staticRenderFns } from "./SithMesRitaTestTaskList.vue?vue&type=template&id=4e5ff5ad&"
import script from "./SithMesRitaTestTaskList.vue?vue&type=script&lang=js&"
export * from "./SithMesRitaTestTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports